import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {Router} from "@angular/router";

@Component({
  selector: 'app-main-button',
  templateUrl: './main-button.component.html',
  styleUrls: ['./main-button.component.scss']
})
export class MainButtonComponent implements OnInit, OnChanges {
  @Output() onClick: EventEmitter<any> = new EventEmitter();
  @Input() data: any;
  @Input() disabled: boolean;
  @Input() buttonText: string = '';
  @Input() myRouterLink: string = '/';
  @Input() myQueryParams: object = {};
  @Input() backgroundColor: string = '#000000'
  @Input() textColor: string = '#FFFFFF'
  @Input() border: string = 'none'
  @Input() buttonHeight: string = 'none'
  @Input() buttonWidth: string = 'none'
  @Input() fontSize: string = 'none'
  @Input() textDecoration: string;
  @Input() fontWeight: string = '700';
  @Input() maxWidth: string;
  
  constructor(public router: Router) {}

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges) {
    let {disabled} = changes;
    if (disabled && (disabled.currentValue !== disabled.previousValue)) {
      this.border = disabled.currentValue ? 'none' : this.border;
    }
  }

  onButtonClick() {
    if (!this.disabled) {
      if (this.onClick.observed) {
        this.onClick.emit(this.data);
      } else {
        this.router.navigate([this.myRouterLink], {queryParams: this.myQueryParams});
      }
    }
  }


}
